import { Box, styled } from "@mui/material";
import { IStyledAssistentButtonProps } from "./types";

const StyledAssistentButton = styled(Box)<IStyledAssistentButtonProps>(({theme})=>({
    ":hover":{
        cursor: "pointer",
    }
}))

export {StyledAssistentButton}